// Author Liang Gangqiang
// Date 2021-08-11 15:43:57

class SithMesMstLocationTagLoct {
constructor({
        id = null,
        loctIdLoc = '',
        loctTagCode = '',
        loctAdditionalCodeA = '',
        loctAdditionalCodeB = '',
        loctAdditionalCodeC = '',
        remark = ''}
= {}) {
    this.id = id;
    this.loctIdLoc = loctIdLoc;
    this.loctTagCode = loctTagCode;
    this.loctAdditionalCodeA = loctAdditionalCodeA;
    this.loctAdditionalCodeB = loctAdditionalCodeB;
    this.loctAdditionalCodeC = loctAdditionalCodeC;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstLocationTagLoct();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'loctIdLoc',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.grid.loctIdLoc',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationCode',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.grid.locationCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'machineType',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.grid.machineType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: 'machine-工作中心' },
                            { value: '2', text: 'man-工作中心' },
                            { value: '3', text: 'virtual' },
                            { value: '4', text: '公司' },
                            { value: '5', text: '部门' },
                            { value: '6', text: '成本中心' },
                            { value: '7', text: '工位' }
            ]
        }
        },
        {
        key: 'loctTagCode',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.grid.loctTagCode',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '外委工位：同一工位排产也不冲突' },
                { value: '2', text: '相同工位，被建立在多个工作中心下，排产冲突，统计需要汇总，关系表中的code相同则排产冲突，code表示具体哪个工位' },
                { value: '3', text: '相同工位，被建立在多个工作中心下，排产不冲突，统计需要汇总' },
                { value: '4', text: '不同工位，但可以干相同类型的活，排产时可由系统自动平衡负荷。关系表中的code相同则可相互平衡负荷，code表示具体什么类型的活' },
                { value: '5', text: 'Labor类型PCNF，且CNF' },
                { value: '6', text: 'Machine类型PCNF，且CNF' },
                { value: '7', text: 'Labor位置次数回写CNF' },
                { value: '8', text: 'Machine位置次数回写CNF' },
                { value: '9', text: '只回写CNF' },
                { value: '10', text: '101收货后CNF' },
                { value: '12', text: 'labor计划工时回写' },
                { value: '14', text: 'machine计划工时回写' },
                { value: '13', text: '工序完工时默认虚入' }
            ]
        }
        },
        {
        key: 'loctAdditionalCodeA',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.grid.loctAdditionalCodeA',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'loctAdditionalCodeB',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.grid.loctAdditionalCodeB',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'loctAdditionalCodeC',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.grid.loctAdditionalCodeC',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    loctIdLocFilter : "",
    loctTagCodeFilter : "",
    loctAdditionalCodeAFilter : "",
    loctAdditionalCodeBFilter : "",
    loctAdditionalCodeCFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'loctIdLocFilter',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.filter.loctIdLoc',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'loctTagCodeFilter',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.filter.loctTagCode',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '外委工位：同一工位排产也不冲突' },
                { value: '2', text: '相同工位，被建立在多个工作中心下，排产冲突，统计需要汇总，关系表中的code相同则排产冲突，code表示具体哪个工位' },
                { value: '3', text: '相同工位，被建立在多个工作中心下，排产不冲突，统计需要汇总' },
                { value: '4', text: '不同工位，但可以干相同类型的活，排产时可由系统自动平衡负荷。关系表中的code相同则可相互平衡负荷，code表示具体什么类型的活' },
                { value: '5', text: 'Labor类型PCNF，且CNF' },
                { value: '6', text: 'Machine类型PCNF，且CNF' },
                { value: '7', text: 'Labor位置次数回写CNF' },
                { value: '8', text: 'Machine位置次数回写CNF' },
                { value: '9', text: '只回写CNF' },
                { value: '10', text: '101收货后CNF' },
                { value: '12', text: 'labor计划工时回写' },
                { value: '14', text: 'machine计划工时回写' },
                { value: '13', text: '工序完工时默认虚入' }
            ]
        }
        },
        {
        key: 'loctAdditionalCodeAFilter',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.filter.loctAdditionalCodeA',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'loctAdditionalCodeBFilter',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.filter.loctAdditionalCodeB',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'loctAdditionalCodeCFilter',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.filter.loctAdditionalCodeC',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'loctIdLoc',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.entity.loctIdLoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'loctTagCode',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.entity.loctTagCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '外委工位：同一工位排产也不冲突' },
                { value: '2', text: '相同工位，被建立在多个工作中心下，排产冲突，统计需要汇总，关系表中的code相同则排产冲突，code表示具体哪个工位' },
                { value: '3', text: '相同工位，被建立在多个工作中心下，排产不冲突，统计需要汇总' },
                { value: '4', text: '不同工位，但可以干相同类型的活，排产时可由系统自动平衡负荷。关系表中的code相同则可相互平衡负荷，code表示具体什么类型的活' },
                { value: '5', text: 'Labor类型PCNF，且CNF' },
                { value: '6', text: 'Machine类型PCNF，且CNF' },
                { value: '7', text: 'Labor位置次数回写CNF' },
                { value: '8', text: 'Machine位置次数回写CNF' },
                { value: '9', text: '只回写CNF' },
                { value: '10', text: '101收货后CNF' },
                { value: '12', text: 'labor计划工时回写' },
                { value: '14', text: 'machine计划工时回写' },
                { value: '13', text: '工序完工时默认虚入' }
            ]
        }
        },
        {
        key: 'loctAdditionalCodeA',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.entity.loctAdditionalCodeA',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'loctAdditionalCodeB',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.entity.loctAdditionalCodeB',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'loctAdditionalCodeC',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.entity.loctAdditionalCodeC',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstLocationTagLoct.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstLocationTagLoct, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
